module.exports = __webpack_public_path__ + "img/thumnail12.ed3671e4.jpg";